/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EntityHint } from './entityHint';
import type { ImportInMeetingType } from './importInMeetingType';
import type { ImportParticipantIn } from './importParticipantIn';
import type { ImportSegmentIn } from './importSegmentIn';

export interface ImportIn {
  started_at: string;
  attested: boolean;
  /**
     * @minItems 1
     * @maxItems 50
     */
  participants: ImportParticipantIn[];
  /**
     * @minItems 1
     * @maxItems 20000
     */
  segments: ImportSegmentIn[];
  entity_hint?: EntityHint | null;
  project_id?: string | null;
  title?: string | null;
  language?: string | null;
  meeting_type?: ImportInMeetingType;
}
